export default "__VITE_ASSET__BtrqlLvQ__"